/* eslint-disable max-lines */
import { PropTypes } from '../propTypes/index.js';

export const globalAttributesPropTypes = {
  'aria-*': PropTypes.any.description('Aria related properties').global(),
  'on-*': PropTypes.func.description('Any supported React event').global(),
  'data-*': PropTypes.any.description('Any data property to attach to the root container').global(),
  'all HTML attributes': PropTypes.any
    .description('HTML attributes such as id, className, autoComplete, href and so on')
    .global(),
  about: PropTypes.any.hidden(),
  accept: PropTypes.any.hidden(),
  acceptCharset: PropTypes.any.hidden(),
  accessKey: PropTypes.any.hidden(),
  action: PropTypes.any.hidden(),
  allowFullScreen: PropTypes.any.hidden(),
  allowTransparency: PropTypes.any.hidden(),
  alt: PropTypes.any.hidden(),
  'aria-activedescendant': PropTypes.any.hidden(),
  'aria-atomic': PropTypes.any.hidden(),
  'aria-autocomplete': PropTypes.any.hidden(),
  'aria-busy': PropTypes.any.hidden(),
  'aria-checked': PropTypes.any.hidden(),
  'aria-colcount': PropTypes.any.hidden(),
  'aria-colindex': PropTypes.any.hidden(),
  'aria-colspan': PropTypes.any.hidden(),
  'aria-controls': PropTypes.any.hidden(),
  'aria-current': PropTypes.any.hidden(),
  'aria-describedby': PropTypes.any.hidden(),
  'aria-details': PropTypes.any.hidden(),
  'aria-disabled': PropTypes.any.hidden(),
  'aria-dropeffect': PropTypes.any.hidden(),
  'aria-errormessage': PropTypes.any.hidden(),
  'aria-expanded': PropTypes.any.hidden(),
  'aria-flowto': PropTypes.any.hidden(),
  'aria-grabbed': PropTypes.any.hidden(),
  'aria-haspopup': PropTypes.any.hidden(),
  'aria-hidden': PropTypes.any.hidden(),
  'aria-invalid': PropTypes.any.hidden(),
  'aria-keyshortcuts': PropTypes.any.hidden(),
  'aria-label': PropTypes.any.hidden(),
  'aria-labelledby': PropTypes.any.hidden(),
  'aria-level': PropTypes.any.hidden(),
  'aria-live': PropTypes.any.hidden(),
  'aria-modal': PropTypes.any.hidden(),
  'aria-multiline': PropTypes.any.hidden(),
  'aria-multiselectable': PropTypes.any.hidden(),
  'aria-orientation': PropTypes.any.hidden(),
  'aria-owns': PropTypes.any.hidden(),
  'aria-placeholder': PropTypes.any.hidden(),
  'aria-posinset': PropTypes.any.hidden(),
  'aria-pressed': PropTypes.any.hidden(),
  'aria-readonly': PropTypes.any.hidden(),
  'aria-relevant': PropTypes.any.hidden(),
  'aria-required': PropTypes.any.hidden(),
  'aria-roledescription': PropTypes.any.hidden(),
  'aria-rowcount': PropTypes.any.hidden(),
  'aria-rowindex': PropTypes.any.hidden(),
  'aria-rowspan': PropTypes.any.hidden(),
  'aria-selected': PropTypes.any.hidden(),
  'aria-setsize': PropTypes.any.hidden(),
  'aria-sort': PropTypes.any.hidden(),
  'aria-valuemax': PropTypes.any.hidden(),
  'aria-valuemin': PropTypes.any.hidden(),
  'aria-valuenow': PropTypes.any.hidden(),
  'aria-valuetext': PropTypes.any.hidden(),
  as: PropTypes.any.hidden(),
  async: PropTypes.any.hidden(),
  autoCapitalize: PropTypes.any.hidden(),
  autoComplete: PropTypes.any.hidden(),
  autoCorrect: PropTypes.any.hidden(),
  autoFocus: PropTypes.any.hidden(),
  autoPlay: PropTypes.any.hidden(),
  autoSave: PropTypes.any.hidden(),
  capture: PropTypes.any.hidden(),
  cellPadding: PropTypes.any.hidden(),
  cellSpacing: PropTypes.any.hidden(),
  challenge: PropTypes.any.hidden(),
  charSet: PropTypes.any.hidden(),
  checked: PropTypes.any.hidden(),
  children: PropTypes.any.hidden(),
  cite: PropTypes.any.hidden(),
  classID: PropTypes.any.hidden(),
  className: PropTypes.any.hidden(),
  color: PropTypes.any.hidden(),
  cols: PropTypes.any.hidden(),
  colSpan: PropTypes.any.hidden(),
  content: PropTypes.any.hidden(),
  contentEditable: PropTypes.any.hidden(),
  contextMenu: PropTypes.any.hidden(),
  controls: PropTypes.any.hidden(),
  coords: PropTypes.any.hidden(),
  crossOrigin: PropTypes.any.hidden(),
  data: PropTypes.any.hidden(),
  datatype: PropTypes.any.hidden(),
  dateTime: PropTypes.any.hidden(),
  default: PropTypes.any.hidden(),
  defaultChecked: PropTypes.any.hidden(),
  defaultValue: PropTypes.any.hidden(),
  defer: PropTypes.any.hidden(),
  dir: PropTypes.any.hidden(),
  disabled: PropTypes.any.hidden(),
  download: PropTypes.any.hidden(),
  draggable: PropTypes.any.hidden(),
  encType: PropTypes.any.hidden(),
  form: PropTypes.any.hidden(),
  formAction: PropTypes.any.hidden(),
  formEncType: PropTypes.any.hidden(),
  formMethod: PropTypes.any.hidden(),
  formNoValidate: PropTypes.any.hidden(),
  formTarget: PropTypes.any.hidden(),
  frameBorder: PropTypes.any.hidden(),
  headers: PropTypes.any.hidden(),
  height: PropTypes.any.hidden(),
  hidden: PropTypes.any.hidden(),
  high: PropTypes.any.hidden(),
  href: PropTypes.any.hidden(),
  hrefLang: PropTypes.any.hidden(),
  htmlFor: PropTypes.any.hidden(),
  httpEquiv: PropTypes.any.hidden(),
  id: PropTypes.any.hidden(),
  inlist: PropTypes.any.hidden(),
  inputMode: PropTypes.any.hidden(),
  integrity: PropTypes.any.hidden(),
  is: PropTypes.any.hidden(),
  itemID: PropTypes.any.hidden(),
  itemProp: PropTypes.any.hidden(),
  itemRef: PropTypes.any.hidden(),
  itemScope: PropTypes.any.hidden(),
  itemType: PropTypes.any.hidden(),
  keyParams: PropTypes.any.hidden(),
  keyType: PropTypes.any.hidden(),
  kind: PropTypes.any.hidden(),
  label: PropTypes.any.hidden(),
  lang: PropTypes.any.hidden(),
  list: PropTypes.any.hidden(),
  loop: PropTypes.any.hidden(),
  low: PropTypes.any.hidden(),
  manifest: PropTypes.any.hidden(),
  marginHeight: PropTypes.any.hidden(),
  marginWidth: PropTypes.any.hidden(),
  max: PropTypes.any.hidden(),
  maxLength: PropTypes.any.hidden(),
  media: PropTypes.any.hidden(),
  mediaGroup: PropTypes.any.hidden(),
  method: PropTypes.any.hidden(),
  min: PropTypes.any.hidden(),
  minLength: PropTypes.any.hidden(),
  multiple: PropTypes.any.hidden(),
  muted: PropTypes.any.hidden(),
  name: PropTypes.any.hidden(),
  nonce: PropTypes.any.hidden(),
  noValidate: PropTypes.any.hidden(),
  onAbort: PropTypes.any.hidden(),
  onAbortCapture: PropTypes.any.hidden(),
  onAnimationEnd: PropTypes.any.hidden(),
  onAnimationEndCapture: PropTypes.any.hidden(),
  onAnimationIteration: PropTypes.any.hidden(),
  onAnimationIterationCapture: PropTypes.any.hidden(),
  onAnimationStart: PropTypes.any.hidden(),
  onAnimationStartCapture: PropTypes.any.hidden(),
  onAuxClick: PropTypes.any.hidden(),
  onAuxClickCapture: PropTypes.any.hidden(),
  onBeforeInput: PropTypes.any.hidden(),
  onBeforeInputCapture: PropTypes.any.hidden(),
  onBlur: PropTypes.any.hidden(),
  onBlurCapture: PropTypes.any.hidden(),
  onCanPlay: PropTypes.any.hidden(),
  onCanPlayCapture: PropTypes.any.hidden(),
  onCanPlayThrough: PropTypes.any.hidden(),
  onCanPlayThroughCapture: PropTypes.any.hidden(),
  onChange: PropTypes.any.hidden(),
  onChangeCapture: PropTypes.any.hidden(),
  onClick: PropTypes.any.hidden(),
  onClickCapture: PropTypes.any.hidden(),
  onCompositionEnd: PropTypes.any.hidden(),
  onCompositionEndCapture: PropTypes.any.hidden(),
  onCompositionStart: PropTypes.any.hidden(),
  onCompositionStartCapture: PropTypes.any.hidden(),
  onCompositionUpdate: PropTypes.any.hidden(),
  onCompositionUpdateCapture: PropTypes.any.hidden(),
  onContextMenu: PropTypes.any.hidden(),
  onContextMenuCapture: PropTypes.any.hidden(),
  onCopy: PropTypes.any.hidden(),
  onCopyCapture: PropTypes.any.hidden(),
  onCut: PropTypes.any.hidden(),
  onCutCapture: PropTypes.any.hidden(),
  onDoubleClick: PropTypes.any.hidden(),
  onDoubleClickCapture: PropTypes.any.hidden(),
  onDrag: PropTypes.any.hidden(),
  onDragCapture: PropTypes.any.hidden(),
  onDragEnd: PropTypes.any.hidden(),
  onDragEndCapture: PropTypes.any.hidden(),
  onDragEnter: PropTypes.any.hidden(),
  onDragEnterCapture: PropTypes.any.hidden(),
  onDragExit: PropTypes.any.hidden(),
  onDragExitCapture: PropTypes.any.hidden(),
  onDragLeave: PropTypes.any.hidden(),
  onDragLeaveCapture: PropTypes.any.hidden(),
  onDragOver: PropTypes.any.hidden(),
  onDragOverCapture: PropTypes.any.hidden(),
  onDragStart: PropTypes.any.hidden(),
  onDragStartCapture: PropTypes.any.hidden(),
  onDrop: PropTypes.any.hidden(),
  onDropCapture: PropTypes.any.hidden(),
  onDurationChange: PropTypes.any.hidden(),
  onDurationChangeCapture: PropTypes.any.hidden(),
  onEmptied: PropTypes.any.hidden(),
  onEmptiedCapture: PropTypes.any.hidden(),
  onEncrypted: PropTypes.any.hidden(),
  onEncryptedCapture: PropTypes.any.hidden(),
  onEnded: PropTypes.any.hidden(),
  onEndedCapture: PropTypes.any.hidden(),
  onError: PropTypes.any.hidden(),
  onErrorCapture: PropTypes.any.hidden(),
  onFocus: PropTypes.any.hidden(),
  onFocusCapture: PropTypes.any.hidden(),
  onGotPointerCapture: PropTypes.any.hidden(),
  onGotPointerCaptureCapture: PropTypes.any.hidden(),
  onInput: PropTypes.any.hidden(),
  onInputCapture: PropTypes.any.hidden(),
  onInvalid: PropTypes.any.hidden(),
  onInvalidCapture: PropTypes.any.hidden(),
  onKeyDown: PropTypes.any.hidden(),
  onKeyDownCapture: PropTypes.any.hidden(),
  onKeyPress: PropTypes.any.hidden(),
  onKeyPressCapture: PropTypes.any.hidden(),
  onKeyUp: PropTypes.any.hidden(),
  onKeyUpCapture: PropTypes.any.hidden(),
  onLoad: PropTypes.any.hidden(),
  onLoadCapture: PropTypes.any.hidden(),
  onLoadedData: PropTypes.any.hidden(),
  onLoadedDataCapture: PropTypes.any.hidden(),
  onLoadedMetadata: PropTypes.any.hidden(),
  onLoadedMetadataCapture: PropTypes.any.hidden(),
  onLoadStart: PropTypes.any.hidden(),
  onLoadStartCapture: PropTypes.any.hidden(),
  onLostPointerCapture: PropTypes.any.hidden(),
  onLostPointerCaptureCapture: PropTypes.any.hidden(),
  onMouseDown: PropTypes.any.hidden(),
  onMouseDownCapture: PropTypes.any.hidden(),
  onMouseEnter: PropTypes.any.hidden(),
  onMouseLeave: PropTypes.any.hidden(),
  onMouseMove: PropTypes.any.hidden(),
  onMouseMoveCapture: PropTypes.any.hidden(),
  onMouseOut: PropTypes.any.hidden(),
  onMouseOutCapture: PropTypes.any.hidden(),
  onMouseOver: PropTypes.any.hidden(),
  onMouseOverCapture: PropTypes.any.hidden(),
  onMouseUp: PropTypes.any.hidden(),
  onMouseUpCapture: PropTypes.any.hidden(),
  onPaste: PropTypes.any.hidden(),
  onPasteCapture: PropTypes.any.hidden(),
  onPause: PropTypes.any.hidden(),
  onPauseCapture: PropTypes.any.hidden(),
  onPlay: PropTypes.any.hidden(),
  onPlayCapture: PropTypes.any.hidden(),
  onPlaying: PropTypes.any.hidden(),
  onPlayingCapture: PropTypes.any.hidden(),
  onPointerCancel: PropTypes.any.hidden(),
  onPointerCancelCapture: PropTypes.any.hidden(),
  onPointerDown: PropTypes.any.hidden(),
  onPointerDownCapture: PropTypes.any.hidden(),
  onPointerEnter: PropTypes.any.hidden(),
  onPointerEnterCapture: PropTypes.any.hidden(),
  onPointerLeave: PropTypes.any.hidden(),
  onPointerLeaveCapture: PropTypes.any.hidden(),
  onPointerMove: PropTypes.any.hidden(),
  onPointerMoveCapture: PropTypes.any.hidden(),
  onPointerOut: PropTypes.any.hidden(),
  onPointerOutCapture: PropTypes.any.hidden(),
  onPointerOver: PropTypes.any.hidden(),
  onPointerOverCapture: PropTypes.any.hidden(),
  onPointerUp: PropTypes.any.hidden(),
  onPointerUpCapture: PropTypes.any.hidden(),
  onProgress: PropTypes.any.hidden(),
  onProgressCapture: PropTypes.any.hidden(),
  onRateChange: PropTypes.any.hidden(),
  onRateChangeCapture: PropTypes.any.hidden(),
  onReset: PropTypes.any.hidden(),
  onResetCapture: PropTypes.any.hidden(),
  onResize: PropTypes.any.hidden(),
  onResizeCapture: PropTypes.any.hidden(),
  onScroll: PropTypes.any.hidden(),
  onScrollCapture: PropTypes.any.hidden(),
  onSeeked: PropTypes.any.hidden(),
  onSeekedCapture: PropTypes.any.hidden(),
  onSeeking: PropTypes.any.hidden(),
  onSeekingCapture: PropTypes.any.hidden(),
  onSelect: PropTypes.any.hidden(),
  onSelectCapture: PropTypes.any.hidden(),
  onStalled: PropTypes.any.hidden(),
  onStalledCapture: PropTypes.any.hidden(),
  onSubmit: PropTypes.any.hidden(),
  onSubmitCapture: PropTypes.any.hidden(),
  onSuspend: PropTypes.any.hidden(),
  onSuspendCapture: PropTypes.any.hidden(),
  onTimeUpdate: PropTypes.any.hidden(),
  onTimeUpdateCapture: PropTypes.any.hidden(),
  onTouchCancel: PropTypes.any.hidden(),
  onTouchCancelCapture: PropTypes.any.hidden(),
  onTouchEnd: PropTypes.any.hidden(),
  onTouchEndCapture: PropTypes.any.hidden(),
  onTouchMove: PropTypes.any.hidden(),
  onTouchMoveCapture: PropTypes.any.hidden(),
  onTouchStart: PropTypes.any.hidden(),
  onTouchStartCapture: PropTypes.any.hidden(),
  onTransitionEnd: PropTypes.any.hidden(),
  onTransitionEndCapture: PropTypes.any.hidden(),
  onVolumeChange: PropTypes.any.hidden(),
  onVolumeChangeCapture: PropTypes.any.hidden(),
  onWaiting: PropTypes.any.hidden(),
  onWaitingCapture: PropTypes.any.hidden(),
  onWheel: PropTypes.any.hidden(),
  onWheelCapture: PropTypes.any.hidden(),
  open: PropTypes.any.hidden(),
  optimum: PropTypes.any.hidden(),
  pattern: PropTypes.any.hidden(),
  placeholder: PropTypes.any.hidden(),
  playsInline: PropTypes.any.hidden(),
  poster: PropTypes.any.hidden(),
  prefix: PropTypes.any.hidden(),
  preload: PropTypes.any.hidden(),
  property: PropTypes.any.hidden(),
  radioGroup: PropTypes.any.hidden(),
  readOnly: PropTypes.any.hidden(),
  rel: PropTypes.any.hidden(),
  rev: PropTypes.any.hidden(),
  required: PropTypes.any.hidden(),
  resource: PropTypes.any.hidden(),
  results: PropTypes.any.hidden(),
  reversed: PropTypes.any.hidden(),
  role: PropTypes.any.hidden(),
  rows: PropTypes.any.hidden(),
  rowSpan: PropTypes.any.hidden(),
  sandbox: PropTypes.any.hidden(),
  scope: PropTypes.any.hidden(),
  scoped: PropTypes.any.hidden(),
  scrolling: PropTypes.any.hidden(),
  seamless: PropTypes.any.hidden(),
  security: PropTypes.any.hidden(),
  selected: PropTypes.any.hidden(),
  shape: PropTypes.any.hidden(),
  size: PropTypes.any.hidden(),
  sizes: PropTypes.any.hidden(),
  slot: PropTypes.any.hidden(),
  span: PropTypes.any.hidden(),
  spellCheck: PropTypes.any.hidden(),
  src: PropTypes.any.hidden(),
  srcDoc: PropTypes.any.hidden(),
  srcLang: PropTypes.any.hidden(),
  srcSet: PropTypes.any.hidden(),
  start: PropTypes.any.hidden(),
  step: PropTypes.any.hidden(),
  style: PropTypes.any.hidden(),
  summary: PropTypes.any.hidden(),
  suppressContentEditableWarning: PropTypes.any.hidden(),
  suppressHydrationWarning: PropTypes.any.hidden(),
  tabIndex: PropTypes.any.hidden(),
  target: PropTypes.any.hidden(),
  title: PropTypes.any.hidden(),
  translate: PropTypes.any.hidden(),
  type: PropTypes.any.hidden(),
  typeof: PropTypes.any.hidden(),
  unselectable: PropTypes.any.hidden(),
  useMap: PropTypes.any.hidden(),
  value: PropTypes.any.hidden(),
  vocab: PropTypes.any.hidden(),
  width: PropTypes.any.hidden(),
  wmode: PropTypes.any.hidden(),
  wrap: PropTypes.any.hidden(),
  'aria-braillelabel': PropTypes.any.hidden(),
  'aria-brailleroledescription': PropTypes.any.hidden(),
  'aria-colindextext': PropTypes.any.hidden(),
  'aria-description': PropTypes.any.hidden(),
  'aria-rowindextext': PropTypes.any.hidden(),
};
